export default __webpack_public_path__ + "static/media/offer__rent.e49b4315.jpg";